export const PoweredBy = () => {
    return <p className="text-xs text-brand-grayLight">Powered by Menyo</p>;
};
